export default __webpack_public_path__ + "static/media/filterIcon.6ee5edb6.svg";